"use client";

import Cookies from "js-cookie";
import { useCallback, useState } from "react";
import { useAuthBackendId } from "@/app/providers/AuthBackendModeProvider/AuthBackendContext";
import { getAuthBackend } from "@/lib/authBackend/resolve";
export function useNoOrgAccessState() {
  const [isLoggingOut, setIsLogginOut] = useState(false);
  const authBackendId = useAuthBackendId();
  const handleSignOut = useCallback(async () => {
    setIsLogginOut(true);
    try {
      await getAuthBackend().signOut();
    } catch (error) {
      console.error("Error signing out:", error);
    } finally {
      Cookies.set("x-org-id", "", {
        path: "/",
        maxAge: 0
      });
      Cookies.set("x-team-id", "", {
        path: "/",
        maxAge: 0
      });
      // Trimble's logout() calls window.location.replace(end_session_endpoint) before
      // resolving. Overriding it here in the same JS tick bypasses session termination.
      if (authBackendId !== "trimble") {
        window.location.href = "/";
      }
    }
  }, [authBackendId]);
  return {
    handleSignOut,
    isLoggingOut
  };
}